export default {
  relatedArticlesTitle: {
    id: 'comparison_page_related_articles_title',
    defaultMessage: 'See all articles',
  },
  relatedComparePagesTitle: {
    id: 'comparison_page_related_compare_page_title',
    defaultMessage: 'Our recent comparisons',
  },
} as const
